import { useState } from 'react';
import { useQueryClient } from 'react-query';
import { useListEntitiesQuery } from '../../api/useListEntitiesQuery';
import { EntityDTO, EntitiesDTO } from '../../DocumentVault.meta';
import { useRouteParams } from '../../hooks/useRouteParams';
import { useDocumentVaultContext } from '../../context/useDocumentVaultContext';
import { useFilterableYearOption } from '../../state/selectors';
import { queryKeys } from '../../api/queryKeys';

interface Params {
  selectedEntity: EntityDTO;
}

export const useOrganizeModal = ({ selectedEntity }: Params) => {
  const queryClient = useQueryClient();

  const [navigatePath, setNavigatePath] = useState<string | null>(null);

  const { clientId, path: routePath, providerType, filterableByYear } = useRouteParams();
  const { isLoading, data } = useListEntitiesQuery({
    clientId,
    path: navigatePath ?? routePath,
    providerType,
    filterableByYear,
  });

  const [destinationPath, setDestinationPath] = useState<string | null>(null);
  const [sourcePath, setSourcePath] = useState<string[]>([selectedEntity.path]);

  const { forceYear } = useDocumentVaultContext();
  const { value: selectedYear } = useFilterableYearOption();
  const year = forceYear || selectedYear;

  const sourceEntities = queryClient.getQueryData(
    queryKeys.listDocumentVaultEntities(
      clientId,
      routePath,
      providerType,
      filterableByYear ? year : null,
    ),
  ) as EntitiesDTO;

  return {
    destinationPath,
    isLoading,
    data,
    navigatePath,
    setDestinationPath,
    setNavigatePath,
    setSourcePath,
    sourcePath,
    sourceEntities,
  };
};
